import React, { useEffect } from "react";
import { Controller } from "react-hook-form";
import { Input } from "antd";

export default function TaskOrderInput({ partner, form, ...props }) {
  const { setValue } = form;

  useEffect(() => {
    if (partner) {
      setValue("task.taskOrder", partner.partnerTask?.taskOrder);
    }
  }, [partner]);

  return (
    <Controller
      control={form.control}
      name="task.taskOrder"
      as={<Input readOnly={true} />}
    />
  );
}
